<template>
    <!-- aria-atomic="false" so only the newly added toast is read out, not the whole stack -->
    <div
        role="status"
        aria-live="polite"
        :aria-atomic="false"
        class="notifications toast toast-bottom toast-end w-full md:w-auto whitespace-normal"
    >
        <Transition name="fade">
            <TransitionGroup
                v-if="notifications.length > 0"
                class="relative"
                name="list"
                tag="div"
            >
                <div
                    v-for="notification in notifications"
                    :key="notification.id"
                    class="alert mb-2 relative text-base"
                    :class="notification.type != null && parseTypeClass(notification.type)"
                >
                    <div class="pr-12">
                        <span>{{ notification.message }}</span>
                        <span 
                            role="button"
                            tabIndex="0"
                            class="btn btn-ghost btn-circle absolute top-1 right-1"
                            @click="closeNotification(notification.id)"
                            @keydown.enter="closeNotification(notification.id)"
                        >
                            <MiscIcon name="x" class="h-5 w-5" />
                        </span>
                    </div>
                </div>
            </TransitionGroup>
        </Transition>
    </div>
</template>

<script setup lang="ts">
import { useNotification } from '#imports'

const { notifications, closeNotification, setDefaultOptions } = useNotification()

setDefaultOptions({
    displayTime: 4,
    keepAlive: false
})

const parseTypeClass = function (type: string) {
    if (type === 'info') {
        return 'alert-info'
    }

    if (type === 'success') {
        return 'alert-success'
    }

    if (type === 'warning') {
        return 'alert-warning'
    }

    if (type === 'error') {
        return 'alert-error'
    }
}
</script>
